const consulta_de_aluno_de_atendimento_educacional_especializado = [
  {
    path: "/consulta-de-aluno-de-atendimento-educacional-especializado",
    redirect: "/consulta-de-aluno-de-atendimento-educacional-especializado",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/consulta-de-aluno-de-atendimento-educacional-especializado",
        name: "consulta_de_aluno_de_atendimento_educacional_especializado",
        component: () =>
          import(
            "@/views/ConsultaDeAlunoDeAtendimentoEducacionalEspecializado/ConsultaDeAlunoDeAtendimentoEducacionalEspecializado.vue"
          ),
      },
    ],
  },
];

export { consulta_de_aluno_de_atendimento_educacional_especializado };
